import React from 'react'
import footerStyle from '../styles/footer.module.scss'
import { Link } from "gatsby"
import { css } from "@emotion/core"
import { MdPhoneInTalk } from "react-icons/md"

const Contact = () =>(

    <div className={footerStyle.contact}>
        <h3 css={css`font-size: 13px;
                    line-height: 30px;
                    text-transform: uppercase;
                    letter-spacing: 2px;
                    color: rgba(25, 26, 30, 0.4);
                    margin-bottom: 5px;
                    `}>
                    ¿Quiéres trabajar conmigo?
        </h3>
        <h2 css={css`
                    font-weight: 700;
                    font-size: 2.2rem;
                    padding-bottom: 1.2rem;
                    `}>¡Hagámos tus <span css={css`color: #A58861;`}>ideas</span> realidad!</h2>
        <div css={css`
        width: 50%; margin: 0 auto 2rem auto;

        @media (max-width: 1000px){
            width: 90%;
        }
        
        
        
        `}>
            <p css={css`font-size: 1.2rem;`}>Programa una llamada de <strong>30 minutos</strong> conmigo totalmente <strong>GRATIS sin compromiso</strong>, donde te asesorarte sobre el desarrollo y la estrategia que la web de tu negocio necesita.</p>
        </div>
        
        <Link to='/contacto/#schedule_form' className="btn_small btn_small__gold" css={css`@media (max-width:500px){padding: 0.75rem 0.75rem !important}`}><MdPhoneInTalk className={footerStyle.contact_phone}/> <span className={footerStyle.contact_text}>Programar llamada ahora</span></Link>

    </div>

)

export default Contact
